import React from "react";
import ErrorBoundary from "../controls/ErrorBoundary";
import ExtensionGate from "../controls/ExtensionGate";
import { useExtensionObjects } from "../ExtensionProvider";
const registerOverlay = (_instanceGroup, id, component, props) => {
    return { id, component, props };
};
const renderOverlay = (overlay) => {
    const props = overlay.props ? overlay.props() : {};
    return (React.createElement(ErrorBoundary, { className: "errorboundary-overlay", key: overlay.id },
        React.createElement(ExtensionGate, { id: overlay.id },
            React.createElement(overlay.component, { ...props }))));
};
export const OverlayContainer = () => {
    const overlays = useExtensionObjects(registerOverlay);
    return React.createElement("div", null, overlays.map((overlay) => renderOverlay(overlay)));
};
export default OverlayContainer;
